import { Container, Section } from '@resolute/ui';
import { useState } from 'react';

import { LeadershipModal } from './components/leadership-modal';
import { LeadershipScrollStory } from './components/leadership-scroll-story';
import { LEADERSHIP, type LeadershipMember } from './leadership-data';

import { PageHero } from '@/components/page-hero';
import { Seo } from '@/lib/seo';

/**
 * Leadership showcase — a scroll-driven stack (see `LeadershipScrollStory`)
 * where each member's card slides away to reveal the next as the user
 * scrolls, each opening a full-detail modal on click.
 */
export default function LeadershipPage() {
  const [selected, setSelected] = useState<LeadershipMember | null>(null);

  return (
    <>
      <Seo
        title="Leadership Team"
        description="Meet the leadership team at Resolute Property Solutions — product, engineering and sales leaders building a transparency-first real estate platform."
        path="/about/leadership"
      />

      <PageHero
        eyebrow="About"
        title="Leadership team."
        titleLine2="The people behind Resolute."
        description="A small, hands-on team building verification-first real estate — in product, engineering and sales."
      />

      <Section>
        <Container>
          {LEADERSHIP.length > 0 ? (
            <LeadershipScrollStory members={LEADERSHIP} onOpen={setSelected} />
          ) : (
            <p className="rounded-lg border border-border bg-muted/30 p-8 text-center text-muted-foreground">
              Leadership profiles will be published here soon.
            </p>
          )}
        </Container>
      </Section>

      <LeadershipModal member={selected} onOpenChange={(open) => !open && setSelected(null)} />
    </>
  );
}
